import AppGlobals from "./AppGlobals";
import {broadcastEvent} from "./Events/EventSource";
import EventActions from "./Events/Actions";

let unlisten = null;
let currentLocation = null;
let currentAction = null;

class NavigationHelper{

    /**
     * Gets the current history location
     * @returns {*}
     */
    static getCurrentLocation(){
        return currentLocation;
    }

    /**
     * Gets the current history state object
     */
    static getCurrentState(){
        return currentLocation ? currentLocation.state : null;
    }

    /**
     * Gets the current action
     * @returns {*}
     */
    static getCurrentAction(){
        return currentAction;
    }

    /**
     * Navigates to the specified url with associated state
     * @param url
     * @param state
     */
    static navigate(url,state){
         return AppGlobals.get('history').push(url,state);
    }

    static init(history){

        //  keep global reference
        AppGlobals.set('history', history );

        unlisten = history.listen((location,action) => {

            //  configure analytics
            if(window.ga){
                window.ga('set', 'page', location.pathname);
            }

            //
            currentLocation = location;
            currentAction = action;

            //
            broadcastEvent(EventActions.LocationChanged,location);

        });

    }

    static release(){
        unlisten();
    }

}

export default NavigationHelper;


// WEBPACK FOOTER //
// ./src/common/NavigationHelper.js